import { jsx as t } from "react/jsx-runtime";
import e from "react";
const n = _ref => {
  let {
    children: r
  } = _ref;
  return /* @__PURE__ */t(e.Fragment, {
    children: r
  });
};
export { n as Theme };